// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

/**
 * "Back to Support tools" — the way out of a tool page.
 *
 * D-SUPPORT-15 folded AI assistant and Support settings into the Support tools hub and REMOVED
 * their sidebar rows. That was the point of a hub, but it left those pages with no route back
 * except the browser button: I took away the exit and did not put one in. Patrick, 2026-08-23:
 * "add a navigation back in the support tools."
 *
 * One shared component rather than a link copied into each page, so a tool added later gets the
 * same affordance by importing it — and the label cannot drift between surfaces (L-067).
 */
import { useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

export default function BackToSupportTools() {
  const navigate = useNavigate()
  return (
    <button onClick={() => navigate('/admin/support/tools')}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 5, border: 'none', background: 'none',
        padding: 0, marginBottom: 10, cursor: 'pointer', font: 'inherit', fontSize: 12.5,
        fontWeight: 600, color: 'var(--color-text-mute)',
      }}>
      <ChevronLeft size={14} aria-hidden="true" /> Support tools
    </button>
  )
}
